import { TextBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useBrokerNewReferralStore } from '../../../state/useBrokerNewReferralStore';

interface RepresentativeSuffixProps {
    required?: boolean;
}

export const RepresentativeSuffix: React.FC<RepresentativeSuffixProps> = ({ required = false }) => {
    const isMobile = isMobileScreen();
    const label = 'Suffix';
    const value = useBrokerNewReferralStore((s) => s.referral.repSuffix);
    const setValue = useBrokerNewReferralStore((s) => s.set_repSuffix);
    return (
        <>
            <TextBox
                id='representativeSuffixTextBox'
                value={value}
                onChange={(newValue) => setValue(newValue)}
                label={label}
                required={required}
                placeholder='Jr, III etc'
                width={isMobile ? '100%' : '100px'}
            />
        </>
    );
};
